<template>
  <div class="home">
    <div
      class="background"
      :style="{
        backgroundImage: 'url(' + require('@/assets/img/mayologobg2.png') + ')'
      }"
    ></div>
    <div class="container">
      <img src="@/assets/img/mayologo.png" />

      <div class="weather">
        <div class="clocktime">
          <p>{{ Date.now() | format_date }}</p>
          <DigitalClock></DigitalClock>
        </div>
        <div class="temp" v-if="weather">
          <img :src="weather.icon" />
          <p>
            <span>{{ weather.icon_text }}</span>
            {{ weather.temperature }}
          </p>
        </div>
      </div>
    </div>
    <div class="center-menu">
      <h1>Get Started</h1>
      <div class="nav">
         <div class="card">
        <!-- <div class="card" @click="goTo('Facility')"> -->
          <img src="@/assets/img/lab.png" />
          <p>Our Facility</p>
        </div>

        <!-- <div class="card" @click="goTo('Manufacturing')"> -->
           <div class="card">
          <img src="@/assets/img/tour.png" />
          <p>Additive Manufacturing</p>
        </div>

 <div class="card">
        <!-- <div class="card" @click="goTo('Engineering')"> -->
          <img src="@/assets/img/equipment.png" />
          <p>The Division of Engineering</p>
        </div>

        <div class="card">
          <!-- <router-link to="/gallery/test">
            <img src="@/assets/img/gallery.png" />
          </router-link> -->
           <img src="@/assets/img/gallery.png" />
          <p>Gallery</p>
        </div>

        <!-- <router-link to="/ourlab/test"><img src="@/assets/img/ourlab.png"></router-link>
        <img src="@/assets/img/equipment.png">
        <img src="@/assets/img/tour.png">
        <img src="@/assets/img/gallery.png">    -->
      </div>
      <div class="nav sub">
        <div class="card sub" @click="amf = true">
          <p>AMF Video</p>
        </div>

        <div class="card sub">
          <p>3D Tour</p>
        </div>

        <div class="card sub" @click="doe = true">
          <p>DOE Video</p>
        </div>

        <div class="card sub" @click="contact = true">
          <p>Contact</p>
        </div>

        <!-- <router-link to="/ourlab/test"><img src="@/assets/img/ourlab.png"></router-link>
        <img src="@/assets/img/equipment.png">
        <img src="@/assets/img/tour.png">
        <img src="@/assets/img/gallery.png">    -->
      </div>
      <transition name="fade">
        <div v-if="contact" class="contact">
          <div class="offclick" @click="contact = false"></div>
          <div class="holder">
            <div class="contact_info">
              <h3>Connect with us</h3>
              <div class="line2"></div>
              <h4>Engineering Offices</h4>
              <h5>Plummer 2-39</h5>
              <h4>Biomechanical Shop</h4>
              <h5>Medical Science SL-16</h5>
              <h4>Additive Manufacturing Facility</h4>
              <h5>Baldwin BA-410</h5>

              <h4>Phone:</h4>
              <h5>(507) 266-4552</h5>
              <h4>Visit us on the intranet:</h4>
              <h5>
                http://intranet.mayo.edu/charlie/ division-engineering-rst/
              </h5>
            </div>

            <!-- <div class="form">
              <div class="step1">
                <div class="inputs">
                  <div class="input full">
                    <h5>Full Name</h5>
                    <input type="text" placeholder="Type to get started..." />
                  </div>
                  <div class="input full">
                    <h5>Email Address</h5>
                    <input type="email" />
                  </div>
                  <div class="input full">
                    <h5>Comments</h5>
                    <input type="comment" />
                  </div>
                  <div class="input full">
                    <button class="btn1"><p>Next Step</p></button>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="amf" class="contact">
          <div class="offclick" @click="amf = false"></div>
          <div class="video holder">
            <!-- <video
              width="100%"
              height="100%"
              controls
              autoplay
              src="https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2FVT3900145_DOE_AMF_Final_5-26-20%20(1).mp4?alt=media&token=238e18df-90ae-47bd-85f4-744d1cc97298"
            ></video> -->
            <video
              width="100%"
              height="100%"
              controls
              autoplay
              src="@/assets/img/AMF.mp4"
            ></video>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div v-if="doe" class="contact">
          <div class="offclick" @click="doe = false"></div>
          <div class="video holder">
            <!-- <video
              width="100%"
              height="100%"
              controls
              autoplay
              src="https://firebasestorage.googleapis.com/v0/b/mayo-3d-54f0b.appspot.com/o/Gallerys%2FDivision%20of%20Engineering%20Mayo.mp4?alt=media&token=1574292f-f3ca-4ef1-b00b-5749cf12ecf5"
            ></video> -->
             <video
              width="100%"
              height="100%"
              controls
              autoplay
              src="@/assets/img/DOE.mp4"
            ></video>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "home",
  components: {},
  data() {
    return {
      weather: null,
      // contact: false,
      amf: false,
      doe: false
    };
  },
  firestore() {
    return {
      data: db.collection("data")
    };
  },
  mounted() {},
  async created() {
    this.getWeather();
  },
  updated() {},
  methods: {
    goTo(page) {
      let vm = this;
      this.cover = true;
      setTimeout(function() {
        vm.$router.push({ name: page });
      }, 500);
    },
    getWeather() {
      let vm = this;
      let url =
        "https://api.weatherapi.com/v1/current.json?key=49bb746827054519bf4185611201210&q=75242";
      let req = new Request(url);
      fetch(req)
        .then(function(response) {
          return response.json();
        })
        .then(response => {
          vm.weather = {};
          vm.weather.icon = response.current.condition.icon;
          vm.weather.icon_text = response.current.condition.text;
          vm.weather.temperature = response.current.temp_f + "°";
        });
    }
  }
};
</script>

<style scoped>
h1 {
  padding-top: 0px;
  position: relative;
}
.container img {
  position: absolute;
  left: 0;
  padding: 30px;
}
.nav.sub {
  padding-top: 0;
}
.card.sub {
  height: fit-content;
  padding: 1% 0;
}
.center-menu {
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: flex-end;
  align-items: center;
      margin-top: -6%;
}
.video .holder {
  padding: 20px;
}
.contact .holder {
  padding: 80px;
}
/* .weather {
  border-top: 2px solid rgba(255, 255, 255, 0.2);
  margin-top: 15px;
  padding-top: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
} */
.weather img {
  filter: brightness(0) invert(1);
}
.temp {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h3 {
  font-family: Palatino;
  color: #ffffff;
  font-size: 50px;
  position: relative;
  padding-top: 0px;
  width: 500px;
  text-align: center;
  font-weight: lighter;
  letter-spacing: 5px;
  text-align: left;
  margin: 0;
}

h4 {
  font-family: AzoSans Bold;
  color: #ffffff;
  font-size: 24px;
  margin: 0;
  padding-top: 20px;
}

h5 {
  font-family: AzoSans;
  color: #ffffff;
  font-size: 24px;
  font-weight: lighter;
  margin: 0;
}

.line2 {
  position: relative;
  height: 8px;
  width: 100px;
  background-color: blue;
  margin-bottom: 20px;
}

.btn1 {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
  border: 0;
  margin-top: 10px;
}

.btn1 p {
  color: #ffffff;
  padding: 10px 10px !important;
  font-family: AzoSans;
  font-size: 25px;
  margin: 0;
}
</style>
